import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './label-owners-schedule.hbs'
import i18n from 'scoreboard/components/i18n'
import FormView from 'scoreboard/components/form-view'
import OnOffToggle from 'scoreboard/components/on-off-toggle'
import SchedulePicker from 'scoreboard/components/schedule-picker'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import PrincipalPanel from 'scoreboard/components/principal-panel'
import formHelper from 'scoreboard/components/form-helper'
import appDisplay from 'scoreboard/components/app-display'
import ImportResults from 'scoreboard/components/import-results-dialog'
import Dataset from 'scoreboard/datasets/model/dataset'
import Import from 'scoreboard/imports/model/import'
import NewRecordOptions from 'scoreboard/datasets/new-record-options'
import unwrapModel from 'scoreboard/components/unwrap-model'

const LABEL_AND_OWNERS = 'label-and-owners'
const SCHEDULE = 'schedule'
const ALL = 'all'
const LABEL = 'label'
const OWNERS = 'owners'

const LabelOwnersSchedule = Backbone.View.extend({
	tagName: 'form',
	className: 'vi-schedule',

	events: {
		'click .new-record-options-container li': 'onClickNewRecordOption',
		'click .cancel': 'close'
	},

	/**
	 * View for editing an import's label, owners and schedule. When initially
	 * creating an import, all 3 are edited together. When editing an import,
	 * the label and owners are edited together, and the schedule is edited
	 * separate from those two. Which things to display on the form is
	 * controlled by options.mode.
	 *
	 * @param options
	 *
	 * @param {Import|Dataset} options.model
	 *
	 * @param {String} [options.mode=ALL] LABEL_AND_OWNERS, SCHEDULE, or ALL
	 */
	initialize: function (options) {
		this.options = options || {}
		this.scheduleData = this.options.model.get('scheduleData') || {}
		this.mode = _.isNil(this.options.mode) ? ALL : this.options.mode
		const MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			submitSecondary: this.submitSecondary.bind(this),
			// it isn't necessary to save brand new imports, so it's fine for
			// new imports to click the primary button right away without making
			// any changes on this step of the wizard
			allowCleanSubmission: this.model.isNew()
		})
	},

	render: function () {
		this.$el.empty().append(template(this.context()))
		this.options.wizard && this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		if (this.mode === ALL) {
			this.renderSaveToggle()
			this.renderPrimaryButton()
			this.$('.banner-description').removeClass('is-not-displayed')
		}

		if (this.isEditingLabel()) {
			this.labelField = new MarkedField({
				el: this.$('[name=label]'),
				validator: requiredValidator
			}).render()
		} else {
			this.$('.import-name').addClass('is-not-displayed')
		}

		if (this.isEditingOwners()) {
			this.renderOwnersPanel()
		}

		if (this.isEditingSchedule()) {
			this.renderScheduleToggle()
			this.renderSchedulePicker()
		} else {
			this.$('.schedule.panel').addClass('is-not-displayed')
		}

		if (this.isDataset()) {
			// #29608 for dataset import schedules, show the add/update or replace
			// toggle
			let hasPrimaryKeyField = this.model?.hasPrimaryKeyField?.()
			if (this.model?.isNew() && this.model?.isDatabase()) {
				// #47952 for new database datasets, since the primary key field
				// is required before advancing to this step of the wizard,
				// we can assume that the dataset has a primary key field
				// even if this.model?.hasPrimaryKeyField?.() does not return true
				// so newRecordOptions will correctly display 'Add & Update Records'
				hasPrimaryKeyField = true
			}
			this.newRecordOptions = new NewRecordOptions({
				replaceAllRecords: this.model.get('replaceAllRecords'),
				hasPrimaryKeyField,
				noConfirmation: true
			})
			this.$('.new-record-options-container').html(this.newRecordOptions.el)
			this.newRecordOptions.render()
			this.$el.addClass('two-box-options-dialog')
		}

		formHelper.writeToDom(this.model.attributes, this.el)

		this.isEditingSchedule() && this.toggleScheduled()

		this.formView.start()

		return this
	},

	renderSaveToggle: function() {
		this.saveToggle = new OnOffToggle({
			name: 'save',
			checked: !this.model.isNew(),
			label: 'admin.import.saveImport'
		})
		this.$('.save-toggle-container').append(this.saveToggle.el)
		this.saveToggle.render()
		this.saveToggle.on('change', checked => {
			this.$('.saved-import-options').toggleClass('is-not-displayed', !checked)
			this.$('.import-behavior-panel').toggleClass('is-not-displayed', !checked)
			if (!checked) {
				this.labelField.removeTooltip()
			}
			this.renderPrimaryButton()
			this.renderScheduleToggle()
			this.renderSchedulePicker()
			this.toggleScheduled()
		})
		this.$('.saved-import-options').toggleClass('is-not-displayed', this.model.isNew())
	},

	renderPrimaryButton: function () {
		let checked = this.saveToggle.val()
		this.$('.save').addClass('is-not-displayed')
		if (checked) {
			if (this.mode === ALL) {
				this.$('.button-primary').text(i18n.get('admin.import.saveAndRun'))
				// #27458 display secondary save button
				this.$('.button-secondary').text(i18n.get('common.save'))
				this.$('.button-secondary').removeClass('is-not-displayed')
			} else {
				this.$('.button-primary').text(i18n.get('common.save'))
			}
		} else {
			this.$('.button-primary').text(i18n.get('admin.import.run'))
			this.$('.button-secondary').addClass('is-not-displayed')
		}
	},

	renderOwnersPanel: function() {
		this.ownersPanel = new PrincipalPanel({
			headingKey: 'common.owners',
			placeholderKey: 'admin.group.addUserGroup',
			currentPrincipals: this.model.get('owners')
		})
		this.ownersPanel.on('change', this.formView.change.bind(this.formView))
		this.ownersPanel.on('change:add', () => this.formView.clearErrors())
		this.$('.owners').html(this.ownersPanel.el)
		this.ownersPanel.render()
	},

	renderScheduleToggle: function() {
		this.scheduleToggle = new OnOffToggle({
			name: 'schedule',
			checked: !_.isEmpty(this.scheduleData.frequency),
			label: i18n.get('admin.import.scheduleImport')
		})
		this.scheduleToggle.on('change', () => this.toggleScheduled())
		this.$('.schedule-toggle-container').html(this.scheduleToggle.el)
		this.scheduleToggle.render()
	},

	renderSchedulePicker: function() {
		this.schedulePicker = new SchedulePicker({
			el: this.$('.schedule-picker'),
			data: this.scheduleData
		})
		this.schedulePicker.render()
	},

	isEditingLabel: function() {
		return this.mode === ALL || this.mode === LABEL_AND_OWNERS
			|| this.mode === LABEL
	},

	isEditingOwners: function() {
		return this.mode === ALL || this.mode === LABEL_AND_OWNERS
			|| this.mode === OWNERS
	},

	isEditingLabelAndOwners: function() {
		return this.mode === ALL || this.mode === LABEL_AND_OWNERS
	},

	isEditingSchedule: function() {
		return this.mode === ALL || this.mode === SCHEDULE
	},

	toggleScheduled: function () {
		let scheduled = this.scheduleToggle.val()
		this.schedulePicker.$el.toggleClass('is-not-displayed', !scheduled)
		this.$('.import-behavior-panel').toggleClass('is-not-displayed', !scheduled)
		this.model.set('scheduled', scheduled)

		if (scheduled && _.isNil(this.model.get('replaceAllRecords'))) {
			// #47383 the first time the schedule is turned on, there may not
			// be a replaceAllRecords property in the model; default to false
			this.model.set('replaceAllRecords', false)
			this.newRecordOptions && this.newRecordOptions.setValue(false)
		}
	},

	context: function () {
		let titleKey = 'admin.import.importSchedule'
		let instructions
		if (this.mode === LABEL_AND_OWNERS) {
			titleKey = 'admin.import.labelAndOwners'
		}
		if (this.mode === ALL) {
			titleKey = 'admin.import.scheduleImport.saveAndSchedule'
			instructions = i18n.get('admin.import.scheduleImport.saveAndSchedule.instructions')
		}
		if (this.mode === LABEL) {
			titleKey = 'admin.import.importName'
		}
		if (this.mode === OWNERS) {
			titleKey = 'admin.import.importOwners'
		}
		if (this.isDataset()) {
			titleKey = 'admin.import.importScheduleAndBehavior'
		}
		return {
			title: i18n.get(titleKey),
			instructions,
			isDataset: this.isDataset()
		}
	},

	saveState: function () {
		if (this.isEditingLabel()) {
			let label = this.$('[name=label]').val()
			this.model.set({ label })
		}
		if (this.isEditingOwners()) {
			let owners = this.ownersPanel.getPrincipals()
			this.model.set({ owners })
		}
		if (this.isEditingSchedule()) {
			let scheduleData = this.schedulePicker.readFromDom()
			let scheduled = this.scheduleToggle.val()
			// #29268 get default timezone from the schedulePicker if it was not
			// displayed in the DOM (ex hourly and minutely schedules)
			let timeZone = scheduleData.timeZone || this.schedulePicker.selectedTz
			this.model.set({ scheduled, scheduleData, timeZone })
			// #56364 if the schedule is turned off, unset the replaceAllRecords value
			if (!scheduled) {
				_.unset(this.model.attributes, 'replaceAllRecords')
			}
		}
		if (this.model.get('dataSourceMetadata').fileIds) {
			// #29607 When dealing with multiple files, remove the singular fileId so
			// it doesn't override the array
			delete this.model.attributes.dataSourceMetadata.fileId
		}
	},

	test: function() {
		if (this.isEditingOwners()) {
			// #29457 Prevent saving imports without owners
			if (this.ownersPanel
				&& _.isEmpty(this.ownersPanel.getPrincipals())) {
				return i18n.get('admin.import.labelAndOwners.principal.required')
			}
		}
	},

	run: function(id) {
		// run now
		let url = 'api/imports/run'
		return this.xhr = $.ajax({
			method: 'post',
			url,
			data: JSON.stringify(this.model),
			success: results => {
				let importResults = new ImportResults({
					results
				})
				if (id) {
					appDisplay.dialog(importResults)
				} else {
					appDisplay.replaceDialog(importResults)
				}
				importResults.on('done', () => {
					_.invoke(this.options.wizard, 'finish', 'import-complete')
				})
			},
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
	},

	save: function() {
		this.saveState()
		let { replaceAllRecords = false } = unwrapModel(this.model)
		let url = _.result(this.model, 'url')
		if (this.isDataset()) {
			if (!this.model.isNew()) {
				// #29608 When changing an import schedule, we need the schedule
				// to know if the data should be appended or overwritten
				url += `/schedule?replaceAllRecords=${replaceAllRecords}`
			}
		}

		return this.model.save({}, {
			url,
			success: () => {
				_.invoke(this.options.wizard, 'finish')
				this.trigger('done', this.model)
			},
			error: (model, response) => {
				let code = _.get(response, 'responseJSON.messageCode')
				// #31587 if a user removes them self as the import owner
				// and no longer has permission to view the returned saved import,
				// do not display the 'not an owner' message, just close the
				// dialog and remove the import from their view
				if (this.isEditingLabelAndOwners() && code === 'admin.import.notOwner') {
					this.trigger('userRemoved', this.model)
					this.trigger('done')
				} else {
					this.formView.error(response)
				}
			}})
	},

	saveAndRun: function() {
		return this.model.save({}, {
			url: _.result(this.model, 'url'),
			success: (results) => {
				this.trigger('done', this.model)
				_.invoke(this.options.wizard, 'finish')
				this.run(results.id)
			},
			error: (model, response) => this.formView.error(response)
		})
	},

	close: function () {
		_.invoke(this.xhr, 'abort')
	},

	/**
	 * Form submission via primary button
	 * May be either "Save", "Run Import", or "Save and Run"
	 */
	submit: function () {
		this.saveState()
		if (_.isNil(this.newRecordOptions)) {
			this._doSubmit()
			return
		}

		this.newRecordOptions.confirmReplaceIfNeeded((replaceAllRecords, cancelled) => {
			if (cancelled) {
				this.formView.start()
				this.formView.change()
				return
			}

			this._doSubmit()
		})
	},

	_doSubmit: function() {
		// if we're not saving the import, we run it immediately
		if (this.mode === ALL && !this.saveToggle.val()) {
			// run now
			this.run()
		} else {
			// save and run for new imports
			if (this.model instanceof Import && this.mode === ALL) {
				this.saveAndRun()
			} else {
				this.save()
			}
		}
	},

	/**
	 * Save via secondary submit button
	 */
	submitSecondary: function () {
		this.save()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.scheduleToggle, this.labelField,
			this.ownersPanel, this.formView, this.saveToggle], 'remove')
	},

	isDataset: function() {
		return this.model instanceof Dataset
	},

	onClickNewRecordOption: function(e) {
		if (this.isDataset()) {
			this.newRecordOptions.handleOptionSelected(e, replaceAllRecords => {
				if (this.model.get('replaceAllRecords') !== replaceAllRecords) {
					this.model.set('replaceAllRecords', replaceAllRecords)
					this.formView.setDirty()
				}
			})
		}
	}
})

export default LabelOwnersSchedule
export { LABEL_AND_OWNERS }
export { SCHEDULE }
export { ALL }
export { LABEL }
export { OWNERS }

LabelOwnersSchedule.__filename__ = 'imports/label-owners-schedule.js'
